import type { CallPath, CallPathJava, SymbolJava } from '../../../../../shared/reachability/types';

/**
 * Build a Java FQSN from a SymbolJava.
 *
 * An FQSN is a "fully qualified symbol name". What goes into a FQSN is going
 * to change a little based on the implementation of each programming language.
 *
 * See /shared/reachability/types.ts for deeper explanations of reachability types.
 */
function buildJavaFQSN(symbol: SymbolJava): string {
  let fqsn = '';
  symbol.forEach((sym) => {
    switch (sym.kind) {
      case 'package':
        fqsn = sym.label;
        break;
      case 'class':
        fqsn = fqsn ? `${fqsn}::${sym.label}` : sym.label;
        break;
      case 'instance_method':
      case 'class_method':
      case 'constructor':
        fqsn = `${fqsn}::${sym.label}`;
        break;
      case 'raw_symbol_segment':
        fqsn = fqsn ? `${fqsn}.${sym.label}` : sym.label;
        break;
      default:
        break;
    }
  });
  return fqsn;
}

/**
 * Build a Java call path into an array of readable Java FQSNs.
 */
function buildCallPathJava(callPath: CallPathJava): string[] {
  return callPath.symbols.map(buildJavaFQSN);
}

/**
 * Build a call path into an array of readable FQSNs.
 *
 * TODO: Is this what `ReachabilityManager.renderCallPath` is meant to do?
 */
export function buildCallPath(callPath: CallPath): string[] {
  if (callPath.kind === 'java') {
    return buildCallPathJava(callPath);
  }
  return [];
}
